/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/** @module LicenseCardModule */

const moduleName = 'license-card';
const componentName = 'license-card';
const prefix = `${moduleName}.${componentName}`;

export const usedLabel = `${prefix}.usedLabel`;
export const availableLabel = `${prefix}.availableLabel`;
export const maxLabel = `${prefix}.maxLabel`;
export const reservedLabel = `${prefix}.reservedLabel`;
export const controllerUsedLabel = `${prefix}.controllerUsedLabel`;
export const controllersInUseTooltipText = `${prefix}.controllersInUseTooltipText`;
export const controllerReservedLabel = `${prefix}.controllerReservedLabel`;
export const controllersInReserveTooltipText = `${prefix}.controllersInReserveTooltipText`;
export const controllerAvailableTooltipText = `${prefix}.controllerAvailableTooltipText`;
export const maximumControllersLabel = `${prefix}.maximumControllersLabel`;
export const poolTitle = `${prefix}.poolTitle`;
export const organizationUsedLabel = `${prefix}.organizationUsedLabel`;
export const organizationsInUseLabel = `${prefix}.organizationsInUseLabel`;
export const licenseTypeLabel = `${prefix}.licenseTypeLabel`;
export const connectivityStatusLabel = `${prefix}.connectivityStatusLabel`;
export const connectedLabel = `${prefix}.connectedLabel`;
export const disconnectedLabel = `${prefix}.disconnectedLabel`;
export const cloudLicensesLabel = `${prefix}.cloudLicensesLabel`;
export const onPremLicensesLabel = `${prefix}.onPremLicensesLabel`;

export const ENGLISH = {
    [usedLabel]: 'Used',
    [availableLabel]: 'Available',
    [maxLabel]: 'Max',
    [reservedLabel]: 'Reserved',
    [controllerUsedLabel]: 'Controller Used',
    [controllersInUseTooltipText]: 'Controllers in use',
    [controllerReservedLabel]: 'Controller Reserved',
    [controllersInReserveTooltipText]: 'Controllers in reserve',
    [controllerAvailableTooltipText]: 'Controllers Available',
    [maximumControllersLabel]: 'Maximum controllers',
    [poolTitle]: 'Pool',
    [organizationUsedLabel]: 'Organization Used',
    [organizationsInUseLabel]: 'Organizations in use',
    [licenseTypeLabel]: 'Type',
    [connectivityStatusLabel]: 'Connectivity Status',
    [connectedLabel]: 'Connected',
    [disconnectedLabel]: 'Disconnected',
    [cloudLicensesLabel]: 'Cloud Licensing',
    [onPremLicensesLabel]: 'On-prem License Hub',
};
